import Const from 'constants';
import SuffixMarker from 'services/simplex/suffix-marker';

const suffix = Const.LP_ITEM_DELIMITER + Const.LP_NON_CONTROLLED_HITTER_STACK_SUFFIX;

const NonControlledHitterStackMarker = {
    suffix,
    ...SuffixMarker,
};

export default NonControlledHitterStackMarker;
